module.exports = __webpack_public_path__ + "static/media/modal-cadastrar-pet.8fb788f9.png";